'use strict'

import { tab } from '@/handler'
import storage from '@/libs/storage'

const get = async (_this) => {
  log('tabController.get()')
  const setTabs = _this.$store._mutations.setTabs[0]
  const tabs = await tab.get()
  log(tabs)
  if (_.size(tabs) > 0) {
    storage.local.setItem('tabs', JSON.stringify(tabs))
    setTabs(tabs)
  }
}

export default {
  get
}
